import { fetchUtils } from "react-admin";

export default (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: "application/json" });
    }
    options.credentials = "include";

    return fetchUtils.fetchJson(url, options);
};



// WEBPACK FOOTER //
// ./src/common/authenticatedHttpClient.js